/**
 * Detect Lovable editor preview / iframe contexts.
 *
 * Service workers must NOT run inside the preview iframe — Lovable rebuilds
 * the app on every edit, which produces a new sw.js hash, which triggers the
 * "A new version is available" banner endlessly. Production users on
 * leadxkids.com are unaffected.
 */
export function isPreviewEnv(): boolean {
  if (typeof window === "undefined") return false;

  let inIframe = false;
  try {
    inIframe = window.self !== window.top;
  } catch {
    inIframe = true; // cross-origin block → assume iframe
  }

  const host = window.location.hostname;
  const isPreviewHost =
    host.includes("id-preview--") ||
    host.endsWith(".lovableproject.com") ||
    host.endsWith(".lovable.app") ||
    host.includes("lovable.dev");

  return inIframe || isPreviewHost;
}
